import DataStructure, { sanitize } from "./DataStructure.js";
import { deepFreeze, timestampToDate } from "../util/misc.js";

export const SALES_GOAL_FIELDS = {
  userID: null,
  year: new Date().getFullYear(),
  targetAmount: 1500000,
  targetContacts: [], // Array of contact IDs

  // Meta info
  created: null,
  createdBy: null,
  modified: null,
  modifiedBy: null,
};
deepFreeze(SALES_GOAL_FIELDS);

export default class SalesGoal extends DataStructure {
  constructor(id, data = {}) {
    data = sanitize(data, SALES_GOAL_FIELDS);

    // Convert to Date
    data.created = timestampToDate(data.created);
    data.modified = timestampToDate(data.modified);

    super(data);

    this.id = id || null;
    this.permissions = Object.freeze({
      view: SalesGoal.canBeViewedBy,
      create: SalesGoal.canBeCreatedBy,
      edit: SalesGoal.canBeEditedBy,
      delete: SalesGoal.canBeDeletedBy,
    });
  }

  // Permissions

  static canBeViewedBy(user, doc) {
    if (user.isAdmin) return true;
    if (doc && doc.data.userID === user.id) return true;
    return false;
  }

  static canBeCreatedBy(user) {
    // Only admin or management can create goals
    return user.isAdmin || user.hasRole("management");
  }

  static canBeEditedBy(user) {
    // Only admin or management can edit goals (not the sales staff themselves)
    return user.isAdmin || user.hasRole("management");
  }

  static canBeDeletedBy(user) {
    // Only admin or management can delete goals
    return user.isAdmin || user.hasRole("management");
  }

  // Database

  get path() {
    return SalesGoal.getPath(this.id);
  }

  static getPath(id) {
    if (id) {
      return `salesGoals/${id}`;
    }
    return "salesGoals";
  }

  static getStateID(path) {
    const match = path.match(/^salesGoals\/([^/]+)$/);
    if (match) {
      return match[1];
    }
    return null;
  }

  get stateID() {
    return this.id;
  }

  toFirestore() {
    return {
      ...this.data,
    };
  }

  static fromFirestore(snapshot, options) {
    const data = snapshot.data(options);
    return new SalesGoal(snapshot.id, data);
  }
}
